export interface PrimaryButtonProps {
  onPrimaryBtn: VoidFunction
  primaryBtnLabel?: string
  /** @default false */
  isPrimaryBtnDisabled?: boolean
  /** @default false */
  isPrimaryBtnLoading?: boolean
  primaryBtnDisabledTooltipCopy?: string
  /** @default publishBtn */
  primaryBtnTestId?: string
}

export interface SecondaryButtonProps {
  /** will not render secondary button if not provided */
  onSecondaryBtn?: VoidFunction
  secondaryBtnLabel?: string
  /** @default false */
  isSecondaryBtnDisabled?: boolean
  /** @default false */
  isSecondaryBtnLoading?: boolean
  secondaryBtnDisabledTooltipCopy?: string
  secondaryBtnTestId?: string
}

export interface CancelButtonProps {
  /** will not render cancel button if not provided */
  onCancel?: VoidFunction
  cancelBtnLabel?: string
  /** @default cancelBtn */
  cancelBtnTestId?: string
}

export interface WizardHeaderProps
  extends PrimaryButtonProps,
    SecondaryButtonProps,
    CancelButtonProps {
  title: string
  className?: string
}
